import { Vue, Component } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";

import { storeModules } from "../../store";
import { IAuthConfigModel } from "../../models/user/auth-config.model";

const UserGetter = namespace(storeModules.User, Getter);

@Component({
	name: "Dashboard",
	template: require("./template.html"),
	components: {
		'dashboard-content': () => import("./components/dashboard-content")
	}
})
export default class Dashboard extends Vue {
	@UserGetter('authConfig') private authConfig: IAuthConfigModel;
	
	get dashboardModuleVisible() {
		return this.authConfig && this.authConfig.Config && this.authConfig.Config.ShowDashboardModule
	}

	
}